var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#EAFFFC",
    stroke: "#00B59A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0132 10.6564C13.9077 10.6564 13.811 10.674 13.7231 10.7091C13.6352 10.7443 13.5473 10.8058 13.4593 10.8938L8.23736 16.1157C8.07912 16.274 8 16.4586 8 16.6696C8 16.8806 8.07912 17.0652 8.23736 17.2234C8.3956 17.3817 8.58462 17.4608 8.8044 17.4608C9.02418 17.4608 9.21319 17.3817 9.37143 17.2234L14.0132 12.5817L18.6549 17.2234C18.8132 17.3817 18.9978 17.4608 19.2088 17.4608C19.4198 17.4608 19.6044 17.3817 19.7626 17.2234C19.9209 17.0652 20 16.8762 20 16.6564C20 16.4366 19.9209 16.2476 19.7626 16.0894L14.567 10.8938C14.4791 10.8058 14.3912 10.7443 14.3033 10.7091C14.2154 10.674 14.1187 10.6564 14.0132 10.6564Z",
    fill: "#00B59A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.88a35253ecacd6fdec7513306dbcc5e1.svg";
export { ForwardRef as ReactComponent };